import { render } from "./ProjectDetail.vue?vue&type=template&id=75c2b12d&ts=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=ts"
export * from "./ProjectDetail.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=75c2b12d&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__